import { axiosEduServer } from "../utils/configAxios";

// Obtener las notificaciones del usuario autenticado
export const getMisNotificaciones = async () => {
  try {
    const { data } = await axiosEduServer.get("/api/Notificacion/mis-notificaciones");
    return data;
  } catch (error) {
    throw error.response?.data || "Error al obtener notificaciones";
  }
};

// Listar notificaciones por ID de usuario (solo para ADM/SADM)
export const getNotificacionesPorUsuario = async (usuarioId) => {
  try {
    const { data } = await axiosEduServer.get(`/api/Notificacion/listar-por-usuario/${usuarioId}`);
    return data;
  } catch (error) {
    throw error.response?.data || "Error al listar notificaciones";
  }
};

// Marcar una notificación como leída
export const marcarNotificacionComoLeida = async (notificacionId) => {
  try {
    const { data } = await axiosEduServer.put(`/api/Notificacion/marcar-como-leido/${notificacionId}`);
    return data;
  } catch (error) {
    throw error.response?.data || "Error al marcar como leída";
  }
};

// Exportar respaldo en Excel (solo para ADM/SADM)
export const exportarRespaldoNotificaciones = async () => {
  try {
    const { data } = await axiosEduServer.get("/api/Notificacion/exportar-respaldo-excel", {
      responseType: "blob", // importante para descargar archivos
    });

    // Crear y descargar el archivo
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `RespaldoNotificaciones.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    throw error.response?.data || "Error al exportar respaldo";
  }
};
